import React from 'react';
import {useDispatch} from 'react-redux';
import { useTranslation } from 'react-i18next';

import BoardConst from '../../utils/constants/board';
import Topmenu from '../topmenu';
import ImgIconComp from './../../../components/imgcomp';
import * as BorderHeaderAction from './../../actions/boardHeader.action';

const BoardHeader = (props: any) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [isToggled,setArrowToggle] = React.useState<boolean>(false);
    const [editDisc,seteditDisc] = React.useState<boolean>(false);
    const [editName,seteditName] = React.useState<boolean>(false);
    const [errorBoardName,errorBoardHandler] = React.useState<string>("");
    const boardNameRef = React.createRef<HTMLInputElement>();
    const boardADescValue = React.createRef<HTMLTextAreaElement>();

    const { board, userPermission, isFavorites } = props.boardDetails;
    const { share_type, sharedMembers = [], description } = board;
    const editPermission = userPermission.editBoard == "1";
    const sharedMembersCount = sharedMembers.length || 0;
    let sharedTypeIcon = "rbrPvtImage";
    if (share_type == BoardConst.BOARD_TYPE_ORG) {
      sharedTypeIcon = "rbr_org_icon";
    } else if (share_type == BoardConst.BOARD_TYPE_SHARED) {
      sharedTypeIcon = "rbr_shared_icon";
    }
    const discSighn =  isToggled ? "rbrUpArrow" : "rbrDownArrow";
    
    const saveBoardName = (e : any) => {
        const name = $.trim(($(boardNameRef.current) as any).val());
        const { board } = props.boardDetails;
        const description = $.trim(($(boardADescValue.current) as any).val());
        if (name == "" || name == null) {
            errorBoardHandler(t("Please enter Board name."));
          return;
        }
        if (errorBoardName) {
            errorBoardHandler("");
        }
        if (name && (e.type == "blur" || e.keyCode == 13)) {
          if (board.name == name) {
            seteditName(false);
            return;
          }
          saveBoardData({ id: board.id, name }, seteditName(false));
        }
    }

    const editBoardName = (e:any, editPermission:any) => {
        if (!editPermission) return false;
        seteditName(true);
    }
    React.useEffect(() => {
        if (editName) {
            boardNameRef.current.focus();
        }
      }, [editName]);

    
    const boardMemberListmouseOver = () => {
        const { sharedMembers } = props.boardDetails.board;
        if (sharedMembers.length) {
          ($(".rbrMemList")as any).show();
        }
    }
    const boardMemberListmouseOut = () => {
        ($(".rbrMemList")as any).hide();
    }
    const editDiscFunc = (e:any, editPermission:any) => {
        if (!editPermission) return false;
        seteditDisc(true);
    }
    React.useEffect(() => {
        if (editDisc) {
            boardADescValue.current.focus();
        }
      }, [editDisc]);

    const saveBoardDesc = (e:any) => {
        const desc = e.target.value.trim();
        const { board } = props.boardDetails;
        if ((e.type == "blur" || e.keyCode == 13)) {
          if (board.description == desc) {
            ($("#brdDescEdit")as any).val(board.description);
            return;
          }
          seteditDisc(false);
          saveBoardData({ id: board.id, description: desc } );
        }
    }

    const saveBoardData = (params:any, callback? :any) => {
        const url = `${wbConfig.baseUrl}/board/saveBoardNameComp`;
        if (typeof url !== "undefined") {
          $.post(url, params).then(resp => {
            if (resp.data) {
              if (typeof callback === "function") {
                updateLeftMenuData("board", resp.data.id, "board", "update", {
                  name: resp.data.name,
                  share_type: resp.data.share_type
                });
                callback.apply(null, [resp.data, params.id]);
              }
              dispatch(BorderHeaderAction.UpdateBoardHeaderData(resp.data));
            } else {
              alert(resp.error);
            }
          });
        }
    }

    const pinClick = (e:any, favourites: any, type:any, id:any) => {
        pinUnpinUserFav(e.target,favourites,id,type,board.name);
    }

    return (
      <div className="sharedBoardsHeaderDiv rectbox-row-wrapper">
        <div className="recboxshadow">
          <div className="sharedBoardHeaderTop">
            <div className="shareBoardPageWrap">
              <div className="left shareBoardTitle">
                <div
                  style={{
                    display: errorBoardName ? "block" : "none"
                  }}
                  className="errorForName"
                >
                  {errorBoardName}
                </div>
                <input
                  ref={boardNameRef}
                  style={{ display: editName ? "block" : "none" }}
                  className="boarTitleClick"
                  type="text"
                  name="board_name"
                  id="board_name"
                  placeholder={t("Board title")}
                  defaultValue={board.name}
                  onKeyDown={e => saveBoardName(e)}
                  onBlur={e => saveBoardName(e)}
                />
                <div
                  style={{ display: !editName ? "block" : "none" }}
                  className={editPermission ? " clickable " : ""}
                  onClick={e => editBoardName(e, editPermission)}
                >
                  {board.name}
                </div>
              </div>
              <div className="left shareBoardOwner">
                <div>{board.fullName}</div>
              </div>
            </div>

            <div>
              <div className="boardMembersWrap">
                <div className="board-img-wrapper">
                  {share_type == BoardConst.BOARD_TYPE_SHARED ? (
                    <div>
                      <div
                        className="boardMembers"
                        onMouseOver={boardMemberListmouseOver}
                        onMouseLeave={boardMemberListmouseOut}
                        >
                        <div className="boardMembersCount">
                          {sharedMembersCount || "0"}
                        </div>
                        <ImgIconComp id={sharedTypeIcon} width="12" height="12" />
                      </div>
                      <div style={{ display: "none" }} className="rbrMemList">
                        {sharedMembers.map((m:any) => (
                          <div className="rbrmemNames" data-id={m.user_id}>
                            {m.fullName}
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <ImgIconComp
                    id={sharedTypeIcon}
                    width="12"
                    height="12"
                    style={{ float: "right" }}
                    />
                    )}
                </div>
                <div
                  className="pinVishualBoard"
                  data-pinstatus={isFavorites}
                  data-type={BoardConst.OBJECT_TYPE_BOARD}
                  data-id={board.id}
                  onClick={(e) => pinClick(e,isFavorites,BoardConst.OBJECT_TYPE_BOARD,board.id)}
                  />
                <div className="board-menu-wrapper">
                  <Topmenu />
                </div>
                <div className="toggleDisc">
                  <div
                    className="boardtitleUpArrow clickable"
                    onClick={() => setArrowToggle(!isToggled)}
                    >
                    <ImgIconComp id={discSighn} width="14" height="10" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="discriptionWrap" style={{ display: isToggled? 'block' : 'none' }}>
            <div
              style={{ display: editDisc ? "none" : "block" }}
              className={editPermission && !editDisc ? " brdDesc clickable" : "brdDesc"}
              onClick={e => editDiscFunc(e, editPermission)}
            >
              {description || (
                <span className="rbr_no_description">
                  {editPermission ? t("Add a description") : t("No description")}
                </span>
              )}
            </div>
            <textarea
              ref={boardADescValue}
              style={{ display: !editDisc ? "none" : "block" }}
              id="brdDescEdit"
              className="brdDescEdit"
              name="boardDisc"
              placeholder={t("Add a description")}
              autoFocus
              onKeyDown={e => saveBoardDesc(e)}
              onBlur={e => saveBoardDesc(e)}
              defaultValue={description}
            />
          </div>
        </div>
      </div>
    )
}

export default BoardHeader;